// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user_bonuses_main_div {
    display: flex;
    flex-direction: column;
    background-color: var(--bg-card);
    padding: 20px;
    border-radius: 15px;
    gap: 15px;
    border: 1px solid var(--border);
    box-shadow: var(--shadow-sm);
}

.user_bonuses_header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 10px;
    flex-wrap: wrap;
}

.user_bonuses_title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: var(--text-primary);
}

.user_bonuses_subtitle {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    color: var(--text-primary);
}

.user_bonuses_total {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: var(--text-primary);
    font-variant-numeric: tabular-nums;
}

.user_bonuses_label {
    font-size: 13px;
    font-weight: 400;
    color: var(--text-muted);
}

.user_bonuses_hint,
.user_bonuses_empty {
    margin: 0;
    font-size: 13px;
    color: var(--text-muted);
}

.user_bonuses_error {
    margin: 0;
    font-size: 13px;
    color: #d93025;
}

.user_bonuses_table_wrapper {
    overflow-x: auto;
}

.user_bonuses_table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    color: var(--text-primary);
}

.user_bonuses_table th {
    text-align: left;
    font-size: 12px;
    font-weight: 600;
    color: var(--text-muted);
    padding: 6px 8px;
    border-bottom: 1px solid var(--border);
    white-space: nowrap;
}

.user_bonuses_table td {
    padding: 8px;
    border-bottom: 1px solid var(--border);
    vertical-align: top;
}

.user_bonuses_table th.user_bonuses_number,
.user_bonuses_number {
    text-align: right;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
}

.user_bonuses_reason {
    display: block;
    font-size: 12px;
    color: var(--text-muted);
    max-width: 260px;
    overflow-wrap: anywhere;
}

.user_bonuses_status {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    border: 1px solid var(--border);
    color: var(--text-muted);
}

.user_bonuses_status_active {
    color: var(--text-primary);
    border-color: var(--primary);
}

.user_bonuses_details summary {
    cursor: pointer;
    font-size: 13px;
    color: var(--text-muted);
    white-space: nowrap;
}

.user_bonuses_details ul {
    list-style: none;
    margin: 8px 0 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 12px;
    min-width: 320px;
}

.user_bonuses_details li {
    display: grid;
    grid-template-columns: auto 1fr auto;
    gap: 8px;
}

.user_bonuses_link_button {
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    font-size: 13px;
    color: var(--primary);
    text-decoration: underline;
    cursor: pointer;
}

.user_bonuses_link_button:disabled {
    color: var(--text-muted);
    cursor: not-allowed;
}

.user_bonuses_cancel {
    margin-top: 6px;
    color: #d93025;
}

.user_bonuses_form {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding-top: 15px;
    border-top: 1px solid var(--border);
}

.user_bonuses_form_row {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
}

.user_bonuses_field {
    display: flex;
    flex-direction: column;
    gap: 5px;
    font-size: 13px;
    color: var(--text-primary);
}

.user_bonuses_field input,
.user_bonuses_field textarea {
    padding: 8px 10px;
    border-radius: var(--radius-sm);
    border: 1px solid var(--border);
    background-color: var(--bg-card);
    color: var(--text-primary);
    font: inherit;
}

.user_bonuses_field input[aria-invalid="true"] {
    border-color: #d93025;
}

.user_bonuses_confirm {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 12px;
    border-radius: var(--radius-sm);
    border: 1px solid var(--primary);
    font-size: 14px;
    color: var(--text-primary);
}

.user_bonuses_confirm p {
    margin: 0;
}

.user_bonuses_confirm_actions {
    display: flex;
    align-items: center;
    gap: 15px;
}

.user_bonuses_visually_hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/pages/users/userById/UserSections/UserBonuses/userBonuses.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;;IAEI,SAAS;IACT,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;;IAEI,iBAAiB;IACjB,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,eAAe;IACf,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,0BAA0B;AAC9B;;AAEA;;IAEI,iBAAiB;IACjB,+BAA+B;IAC/B,+BAA+B;IAC/B,gCAAgC;IAChC,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,+BAA+B;IAC/B,gCAAgC;IAChC,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB","sourcesContent":[".user_bonuses_main_div {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--bg-card);\n    padding: 20px;\n    border-radius: 15px;\n    gap: 15px;\n    border: 1px solid var(--border);\n    box-shadow: var(--shadow-sm);\n}\n\n.user_bonuses_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.user_bonuses_title {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.user_bonuses_subtitle {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.user_bonuses_total {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 700;\n    color: var(--text-primary);\n    font-variant-numeric: tabular-nums;\n}\n\n.user_bonuses_label {\n    font-size: 13px;\n    font-weight: 400;\n    color: var(--text-muted);\n}\n\n.user_bonuses_hint,\n.user_bonuses_empty {\n    margin: 0;\n    font-size: 13px;\n    color: var(--text-muted);\n}\n\n.user_bonuses_error {\n    margin: 0;\n    font-size: 13px;\n    color: #d93025;\n}\n\n.user_bonuses_table_wrapper {\n    overflow-x: auto;\n}\n\n.user_bonuses_table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 14px;\n    color: var(--text-primary);\n}\n\n.user_bonuses_table th {\n    text-align: left;\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--text-muted);\n    padding: 6px 8px;\n    border-bottom: 1px solid var(--border);\n    white-space: nowrap;\n}\n\n.user_bonuses_table td {\n    padding: 8px;\n    border-bottom: 1px solid var(--border);\n    vertical-align: top;\n}\n\n.user_bonuses_table th.user_bonuses_number,\n.user_bonuses_number {\n    text-align: right;\n    font-variant-numeric: tabular-nums;\n    white-space: nowrap;\n}\n\n.user_bonuses_reason {\n    display: block;\n    font-size: 12px;\n    color: var(--text-muted);\n    max-width: 260px;\n    overflow-wrap: anywhere;\n}\n\n.user_bonuses_status {\n    display: inline-block;\n    padding: 2px 8px;\n    border-radius: 999px;\n    font-size: 12px;\n    font-weight: 600;\n    border: 1px solid var(--border);\n    color: var(--text-muted);\n}\n\n.user_bonuses_status_active {\n    color: var(--text-primary);\n    border-color: var(--primary);\n}\n\n.user_bonuses_details summary {\n    cursor: pointer;\n    font-size: 13px;\n    color: var(--text-muted);\n    white-space: nowrap;\n}\n\n.user_bonuses_details ul {\n    list-style: none;\n    margin: 8px 0 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    font-size: 12px;\n    min-width: 320px;\n}\n\n.user_bonuses_details li {\n    display: grid;\n    grid-template-columns: auto 1fr auto;\n    gap: 8px;\n}\n\n.user_bonuses_link_button {\n    background: none;\n    border: none;\n    padding: 0;\n    font: inherit;\n    font-size: 13px;\n    color: var(--primary);\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.user_bonuses_link_button:disabled {\n    color: var(--text-muted);\n    cursor: not-allowed;\n}\n\n.user_bonuses_cancel {\n    margin-top: 6px;\n    color: #d93025;\n}\n\n.user_bonuses_form {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    padding-top: 15px;\n    border-top: 1px solid var(--border);\n}\n\n.user_bonuses_form_row {\n    display: flex;\n    gap: 15px;\n    flex-wrap: wrap;\n}\n\n.user_bonuses_field {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    font-size: 13px;\n    color: var(--text-primary);\n}\n\n.user_bonuses_field input,\n.user_bonuses_field textarea {\n    padding: 8px 10px;\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--border);\n    background-color: var(--bg-card);\n    color: var(--text-primary);\n    font: inherit;\n}\n\n.user_bonuses_field input[aria-invalid=\"true\"] {\n    border-color: #d93025;\n}\n\n.user_bonuses_confirm {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 12px;\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--primary);\n    font-size: 14px;\n    color: var(--text-primary);\n}\n\n.user_bonuses_confirm p {\n    margin: 0;\n}\n\n.user_bonuses_confirm_actions {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n}\n\n.user_bonuses_visually_hidden {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n    clip: rect(0 0 0 0);\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
